export default __webpack_public_path__ + "images/care_coordination_case.6511a0d9066625b4ca0cb7d0329ba166.svg";